module.exports = __webpack_public_path__ + "assets/img/contact.3b9210d8.png";